<template>
  <div class="log-management anim-fade-in-up">
    <div class="content-card" style="padding: 16px 20px 4px; margin-bottom: 18px;">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="登录日志" name="LOGIN">
          <div class="filter-bar">
            <div class="filter-left">
              <span class="date-range-wrap">
                <el-date-picker v-model="loginStartDate" type="date" placeholder="开始日期" size="small" value-format="yyyy-MM-dd" style="width: 138px;" />
                <span class="date-sep">至</span>
                <el-date-picker v-model="loginEndDate" type="date" placeholder="结束日期" size="small" value-format="yyyy-MM-dd" style="width: 138px;" />
              </span>
              <el-input v-model="loginUsername" placeholder="搜索用户名..." size="small" style="width: 180px;" clearable @keyup.enter.native="refreshLogs" />
              <el-select v-model="loginStatus" placeholder="状态" size="small" style="width: 100px;" clearable @change="refreshLogs">
                <el-option label="成功" value="SUCCESS" /><el-option label="失败" value="FAIL" />
              </el-select>
              <el-button size="small" icon="el-icon-search" @click="refreshLogs">查询</el-button>
              <el-button size="small" @click="resetFilter('LOGIN')">重置</el-button>
            </div>
            <div class="filter-right">
              <el-button size="small" icon="el-icon-refresh" @click="refreshLogs">刷新</el-button>
              <el-button size="small" icon="el-icon-download" @click="exportLogs">导出CSV</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="OPERATION">
          <div class="filter-bar">
            <div class="filter-left">
              <span class="date-range-wrap">
                <el-date-picker v-model="operationStartDate" type="date" placeholder="开始日期" size="small" value-format="yyyy-MM-dd" style="width: 138px;" />
                <span class="date-sep">至</span>
                <el-date-picker v-model="operationEndDate" type="date" placeholder="结束日期" size="small" value-format="yyyy-MM-dd" style="width: 138px;" />
              </span>
              <el-input v-model="operationUsername" placeholder="搜索用户名..." size="small" style="width: 180px;" clearable @keyup.enter.native="refreshLogs" />
              <el-select v-model="operationType" placeholder="操作类型" size="small" style="width: 120px;" clearable @change="refreshLogs">
                <el-option label="注册" value="用户注册" /><el-option label="修改密码" value="修改密码" />
                <el-option label="修改信息" value="修改用户信息" /><el-option label="删除用户" value="删除用户" />
                <el-option label="修改角色" value="修改角色" />
              </el-select>
              <el-button size="small" icon="el-icon-search" @click="refreshLogs">查询</el-button>
              <el-button size="small" @click="resetFilter('OPERATION')">重置</el-button>
            </div>
            <div class="filter-right">
              <el-button size="small" icon="el-icon-refresh" @click="refreshLogs">刷新</el-button>
              <el-button size="small" icon="el-icon-download" @click="exportLogs">导出CSV</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="content-card" style="padding: 4px;">
      <el-table :data="logList" border stripe v-loading="loading" size="small" style="width: 100%">
        <template v-if="activeTab === 'LOGIN'">
          <el-table-column prop="username" label="用户名" min-width="100" />
          <el-table-column prop="operation" label="操作" min-width="110" show-overflow-tooltip />
          <el-table-column prop="detail" label="详情" min-width="180" show-overflow-tooltip />
          <el-table-column prop="ip" label="IP地址" min-width="130" />
          <el-table-column prop="location" label="归属地" min-width="120" show-overflow-tooltip />
          <el-table-column label="状态" min-width="70">
            <template slot-scope="{row}">
              <el-tag :type="row.status==='SUCCESS'?'success':'danger'" size="mini">{{ row.status==='SUCCESS'?'成功':'失败' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="时间" min-width="150">
            <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ').substring(0,19) : '' }}</template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="username" label="用户名" min-width="100" />
          <el-table-column prop="operation" label="操作类型" min-width="100" />
          <el-table-column prop="detail" label="详情" min-width="220" show-overflow-tooltip />
          <el-table-column prop="ip" label="IP地址" min-width="130" />
          <el-table-column prop="location" label="归属地" min-width="120" show-overflow-tooltip />
          <el-table-column label="时间" min-width="150">
            <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ').substring(0,19) : '' }}</template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div v-if="total > 0" class="pagination-bar">
      <el-pagination
        background
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        :page-sizes="[10,20,50,100]"
        layout="total, sizes, prev, pager, next"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

  </div>
</template>

<style scoped>
.page-title {
  font-family: var(--font-display);
  font-size: 1.5rem; font-weight: 500;
  color: var(--text-primary); margin: 0 0 20px; letter-spacing: 0.04em;
}

.content-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.filter-bar { display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; margin-bottom: 4px; }
.filter-left { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.filter-right { display: flex; gap: 10px; align-items: center; flex-shrink: 0; }
.pagination-bar { display: flex; justify-content: flex-end; margin-top: 18px; }
.date-range-wrap { display: inline-flex; align-items: center; gap: 6px; }
.date-sep { font-size: 0.8rem; color: var(--text-muted); flex-shrink: 0; }
</style>

<script>
export default {
  data() {
    return {
      activeTab: 'LOGIN',
      logList: [], loading: false, page: 1, pageSize: 20, total: 0,
      loginStartDate: '', loginEndDate: '', loginUsername: '', loginStatus: '',
      operationStartDate: '', operationEndDate: '', operationUsername: '', operationType: ''
    }
  },
  created() { this.fetchLogs(); },
  methods: {
    async fetchLogs(p) {
      if (p) this.page = p;
      this.loading = true;
      const isLogin = this.activeTab === 'LOGIN';
      const params = {
        page: this.page, pageSize: this.pageSize, logType: this.activeTab,
        username: isLogin ? (this.loginUsername || undefined) : (this.operationUsername || undefined),
        status: isLogin ? (this.loginStatus || undefined) : undefined,
        operation: !isLogin ? (this.operationType || undefined) : undefined
      };
      if (isLogin) {
        if (this.loginStartDate) params.startDate = this.loginStartDate;
        if (this.loginEndDate) params.endDate = this.loginEndDate;
      } else {
        if (this.operationStartDate) params.startDate = this.operationStartDate;
        if (this.operationEndDate) params.endDate = this.operationEndDate;
      }
      try {
        const resp = await this.$axios.get('/adm/logs', { params });
        if (resp.data.code === 0) { const d = resp.data.data; this.logList = d.list || []; this.total = d.total || 0; }
      } catch (e) { console.error(e); } finally { this.loading = false; }
    },
    refreshLogs() { this.fetchLogs(1); },
    handleTabClick() { this.page = 1; this.fetchLogs(); },
    resetFilter(tab) {
      if (tab === 'LOGIN') { this.loginStartDate = ''; this.loginEndDate = ''; this.loginUsername = ''; this.loginStatus = ''; }
      else { this.operationStartDate = ''; this.operationEndDate = ''; this.operationUsername = ''; this.operationType = ''; }
      this.page = 1; this.fetchLogs();
    },
    handlePageChange(p) { this.fetchLogs(p); },
    handleSizeChange(s) { this.pageSize = s; this.fetchLogs(1); },
    async exportLogs() {
      const isLogin = this.activeTab === 'LOGIN';
      const params = {
        logType: this.activeTab,
        username: isLogin ? (this.loginUsername || undefined) : (this.operationUsername || undefined),
        status: isLogin ? (this.loginStatus || undefined) : undefined,
        operation: !isLogin ? (this.operationType || undefined) : undefined
      };
      if (isLogin) {
        if (this.loginStartDate) params.startDate = this.loginStartDate;
        if (this.loginEndDate) params.endDate = this.loginEndDate;
      } else {
        if (this.operationStartDate) params.startDate = this.operationStartDate;
        if (this.operationEndDate) params.endDate = this.operationEndDate;
      }
      try {
        const resp = await this.$axios.get('/adm/logs/export', { params, responseType: 'blob' });
        const url = URL.createObjectURL(new Blob([resp.data], { type: 'text/csv;charset=UTF-8' }));
        const a = document.createElement('a'); a.href = url; a.download = 'log_export.csv';
        document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
        this.$message.success('导出完成');
      } catch (e) { this.$message.error('导出失败'); }
    }
  }
}
</script>
